// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

const e = {
  production: true, // Set to true before the production build and deployment
  serverUrl: '',
  rootUrl: '',
  loginUrl: '/login',
  assets: '../../../assets',
  wsEndpoint: '',
  wsReconnectInterval: 2000,
  refreshInterval: 60000,
  stage: 'ljprod',
  apiServiceId: 'omyl2vs6bi',
  accessKeyId: '',
  secretAccessKey: '',
  column_name: 'Parent Node',
  custom_field: 'subclass_id',
  prod_labels: ['Total', 'Division', 'Department', 'Class'],
  bourneUrl: '',
  region: 'us-east-1',
  cognito: {
    userPoolId: 'us-east-1_oOuW4SZIe',
    userPoolClientId: '4k0ciak32b4jsp1u58l9pabv62',
    oauthDomain: 'us-east-1oouw4szie.auth.us-east-1.amazoncognito.com',
    redirectSignIn: [
      'http://localhost:4200/',
      'https://dag7n2yjuayyq.cloudfront.net/',
      'https://lucky-prod.sizeo.ai/'
    ],
    redirectSignOut: [
      'http://localhost:4200/logout/',
      'https://dag7n2yjuayyq.cloudfront.net/logout/',
      'https://lucky-prod.sizeo.ai/logout/'
    ]
  },
  appsync: {
    endpoint: 'https://bdupipshirbjfmmorqgvz7mjpq.appsync-api.us-east-1.amazonaws.com/graphql'
  }
}

export const environment = e

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
